module.exports = __webpack_public_path__ + "img/icon_heart_11.ef4720d2.svg";